import { render, staticRenderFns } from "./cateCheck.vue?vue&type=template&id=09784795&scoped=true&"
import script from "./cateCheck.vue?vue&type=script&lang=js&"
export * from "./cateCheck.vue?vue&type=script&lang=js&"
import style0 from "./cateCheck.vue?vue&type=style&index=0&id=09784795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09784795",
  null
  
)

export default component.exports